var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.reversed)?_c('v-icon',{staticClass:"reversed"},[_vm._v(_vm._s(_vm.icon))]):_c('v-icon',{staticClass:"regular"},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }